import React from 'react';
import Constants from 'constants';


const iconBank = (payload) => {
    const { id = '', name = '', className = '' } = payload,
        _iconPlaceholder = '';
    switch (id) {
        case Constants.icons.AMENITIES.SWIMMING_POOL: {
            return (
                <span className={className}>
                    <use xlinkHref='icons.svg#air-conditioner' />
                </span>
            );
        }
        case Constants.icons.AMENITIES.FREE_BREAKFAST: {
            return (
                <span className={className}>
                    <i className="fas fa-utensils"></i>
                </span>
            );
        }
        case Constants.icons.AMENITIES.HIGH_SPEED_INTERNET: {
            return (
                <span className={className}>
                    <i className="fas fa-wifi"></i>
                </span>
            );
        }
        case Constants.icons.AMENITIES.AIRPORT_TRANSPORTATION: {
            return (
                <span className={className}>
                    <i className="fas fa-taxi"></i>
                </span>
            );
        }
        case Constants.icons.AMENITIES.FREE_PARKING: {
            return (
                <span className={className}>
                    <i className="fas fa-parking"></i>
                </span>
            );
        }
        case Constants.icons.AMENITIES.KITCHEN_AMENITY: {
            return (
                <span className={className}>
                    <use xlinkHref='icons.svg#cooking' />
                </span>
            );
        }
        case Constants.icons.AMENITIES.GYM: {
            return (
                <span className={className}>
                    <i className="fas fa-dumbbell"></i>
                </span>
            );
        }
        case Constants.icons.AMENITIES.PETS_ALLOWED: {
            return (
                <span className={className}>
                    <i className="fas fa-dog"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.MAP: {
            return (
                <span className={className}>
                    <i className="fas fa-map"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.LEFTARROW: {
            return (
                <span className={className}>
                    <i className="fas fa-chevron-left"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.SORT_UP: {
            return (
                <span className={className}>
                    <i className="fas fa-sort-up"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.SORT_DOWN: {
            return (
                <span className={className}>
                    <i className="fas fa-sort-down"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.SEARCH: {
            return (
                <span className={className}>
                    <i className="fas fa-search"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.MINUS: {
            return (
                <span className={className}>
                    <i className="fas fa-minus"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.PLUS: {
            return (
                <span className={className}>
                    <i className="fas fa-plus"></i>
                </span>);
        }
        case Constants.icons.COMMON.ANGEL_DOWN: {
            return (
                <span className={className}>
                    <i className="fas fa-angle-down"></i>
                </span>
            );
        }
        case Constants.icons.COMMON.OPTION_DOWN: {
            return (
                <span className={className}>
                    <i class='fas fa-chevron-circle-down'></i>
                </span>
            );
        }
        case Constants.icons.COMMON.OPTION_UP: {
            return (
                <span className={className}>
                    <i class='fas fa-chevron-circle-up'></i>
                </span>
            );
        }
        case Constants.icons.COMMON.CLOSE: {
            return (
                <span className={className}>
                    <i className="fas fa-times"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.ONE_STAR: {
            return (
                <span className={className}>
                    <i className="fas fa-star"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.ONE_START_REGULAR: {
            return (
                <span className={className}>
                    <i className="far fa-star"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.LOCATION: {

            return (
                <span className={className}>
                    <i className="fas fa-map-marker-alt"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.CALENDER: {
            return (
                <span className={className}>
                    <i className="far fa-calendar-check"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.DELETE: {
            return (
                <span className={className}>
                    <i className="fas fa-trash-alt"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.SEND_MAIL: {
            return (
                <span className={className}>
                    <i className="fas fa-paper-plane"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.USER: {
            return (
                <span className={className}>
                    <i className="fas fa-user"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.FACEBOOK: {
            return (
                <span className={className}>
                    <i className="fab fa-facebook-f"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.TWITTER: {
            return (
                <span className={className}>
                    <i className="fab fa-twitter"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.INSTAGRAM: {
            return (
                <span className={className}>
                    <i className="fab fa-instagram"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.PINTEREST: {
            return (
                <span className={className}>
                    <i className="fab fa-pinterest"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.ANGEL_RIGHT: {
            return (
                <span className={className}>
                    <i className="fas fa-chevron-right"></i>
                </span>
            );
        }
        case Constants.icons.COMMON.HOTEL_NODATA: {
            return (
                <span className={className}>
                    <i className="fas fa-hotel"></i>
                </span>
            );
        }
        case Constants.icons.COMMON.ASIDE_MENUBAR: {
            return (
                <span className={className}>
                    <i className="fas fa-bars"></i>
                </span>
            );
        }
        case Constants.icons.COMMON.ANGLE_UP: {
            return (
                <span className={className}>
                    <i className="fas fa-angle-up"></i>
                </span>
            );
        }
        case Constants.icons.COMMON.REFRESH: {
            return (
                <span className={className}>
                    <i className="fas fa-sync-alt"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.REVIEW: {
            return (
                <span className={className}>
                    <i className="fas fa-file-alt"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.CREDIT_CARD: {
            return (
                <span className={className}>
                    <i className="far fa-credit-card"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.BED: {
            return (
                <span className={className}>
                    <i className="fas fa-bed"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.GIFT: {
            return (
                <span className={className}>
                    <i className="fa fa-gift"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.HOTEL: {
            return (
                <span className={className}>
                    <i className="fa fa-bed"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.AIR: {
            return (
                <span className={className}>
                    <i className="fa fa-plane"></i>
                </span>
            );
        }

        case Constants.icons.COMMON.RAIL: {
            return (
                <span className={className}>
                    <i className="fa fa-train"></i>
                </span>
            );
        }
        case Constants.icons.COMMON.BUILDING: {
            return (
                <span className={className}>
                    <i class="fa fa-building"></i>
                </span>
            );
        }

        default:
            return _iconPlaceholder;
    }
}

export default iconBank;
